import { Directive, ViewContainerRef, TemplateRef, OnInit, Input } from '@angular/core';

import { LoginService } from '../login/login.service';

@Directive({
    selector: '[appViperBrandIs]'
})
export class BrandIsDirective implements OnInit {

    @Input('appViperBrandIs') brands: string[] = [];

    constructor(
        private viewContainerRef: ViewContainerRef,
        private template: TemplateRef<any>,
        private authService: LoginService,
    ) { }

    ngOnInit(): void {
        this.authService.getCurrentApp()
        .subscribe(app => {
            this.viewContainerRef.clear();
            if (this.brands.includes(app.short_name)) {
                this.viewContainerRef.createEmbeddedView(this.template);
            }
        });
    }
}
